'use client'
import { Divider as ChakraDivider } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { DividerProps } from './Divider.types'

export default forwardRef(function Divider(
  props: DividerProps,
  ref: LegacyRef<HTMLHRElement>
) {
  return <ChakraDivider {...props} ref={ref} translate="no" />
})
